import React from 'react';
type Tone = 'creme' | 'paper' | 'graphite';
interface SectionProps {
  id?: string;
  tone?: Tone;
  className?: string;
  children: React.ReactNode;
  labelledBy?: string;
}
const toneClasses: Record<Tone, string> = {
  creme: 'bg-creme text-graphite',
  paper: 'bg-white text-graphite',
  graphite: 'bg-graphite text-creme'
};
export function Section({
  id,
  tone = 'creme',
  className = '',
  children,
  labelledBy
}: SectionProps) {
  return <section id={id} aria-labelledby={labelledBy} className={`w-full border-t ${tone === 'graphite' ? 'border-warm-lineDark' : 'border-warm-line'} ${toneClasses[tone]} ${className}`} data-id="element-228" data-mp="chrl71zle9zx">
      <div className="mx-auto w-full max-w-6xl px-6 py-20 md:px-10 md:py-28" data-id="element-229" data-mp="7oyfaase0vm9">
        {children}
      </div>
    </section>;
}
export function Eyebrow({
  children,
  tone = 'light'
}: {
  children: React.ReactNode;
  tone?: 'light' | 'dark';
}) {
  return <p className={`mb-5 text-[0.7rem] font-semibold uppercase tracking-[0.18em] ${tone === 'dark' ? 'text-creme/60' : 'text-warm'}`} data-id="element-230" data-mp="106tyjxn71gom">
      {children}
    </p>;
}
export function YouAreHereDot({
  className = ''
}: {
  className?: string;
}) {
  return <span aria-hidden="true" className={`inline-block h-2 w-2 shrink-0 rounded-full bg-rouge ${className}`} data-id="element-231" data-mp="38dxb70dmd2w5" />;
}